import { getIsUpdatingSlogan, getSlogan } from 'store/profile';
import { actionCreators as programItemsAc, getIsDone } from 'store/programItems';

import { CardProps } from 'components/molecules/Card';
import CardDetailSlogan from 'components/molecules/Card/Detail/Slogan';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state: any, ownProps: { id: string }): CardProps & any => ({
	isDone: getIsDone(state, ownProps.id),
	// get slogan from profile reducer -> PULSWM-1425
	slogan: getSlogan(state),
	isUpdatingSlogan: getIsUpdatingSlogan(state),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doSaveSlogan: programItemsAc.doSlogan,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(CardDetailSlogan as any);
